import {gsap} from "gsap";

const Accordion = {

    container: {},

    init: function () {
        this.container = $('section[url="faq"]');
        this.headers = 'h2, h3, h4, h5';
        this.container
            .find(this.headers)
            .unbind('click')
            .click(function (event) {
                if (!$(this).is('.expanded')) {
                    Accordion.open($(this));
                } else {
                    Accordion.close($(this))
                }
            }).each(function (index) {
            $(this).attr("headline-id", index);
        })
        ;
    },

    open: function (item) {
        Accordion.close(this.container.find('.expanded'));

        const content = $(item).next('p');
        const height = content.innerHeight();

        gsap.set(content, {height: 'auto', paddingBottom: 16})
        gsap.from(content, {
            height: 0, paddingBottom: 0, onComplete: () => {
                content.prev(this.headers).addClass('expanded');
            }
        })
    },

    close: function (item) {
        const content = $(item).next('p');

        gsap.to(content, {
            height: 0, paddingBottom: 0, onComplete: () => {
                content.prev(this.headers).removeClass('expanded');
            }
        })
    }
};

export default Accordion;